import { render, staticRenderFns } from "./motivos-evento-form.vue?vue&type=template&id=4328bad8"
import script from "./motivos-evento-form.vue?vue&type=script&lang=js"
export * from "./motivos-evento-form.vue?vue&type=script&lang=js"
import style0 from "./motivos-evento-form.vue?vue&type=style&index=0&id=4328bad8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports